export const APP_ROUTER = {
  HOME: '/',
  DASHBOARD: '/dashboard',
  KPI_INITIATIVES: '/kpi-initiatives',
  APP_USAGE: '/app-usage',
  COMPANY_REPORT: '/company-report',
  NOT_FOUND: '/404',
  EXAMPLE: '/example',
  USER: {
    LIST: '/user',
    DETAIL: '/user/:id',
    CREATE: '/user/create',
    UPDATE: '/user/update/:id',
  },
  POST: {
    LIST: '/post',
    DETAIL: '/post/:id',
  },
  POST_FUKUMARU: {
    LIST: '/fukumaru',
    DETAIL: '/fukumaru/:id',
    UPDATE: '/fukumaru/update/:id',
  },
  SPECIAL_DAY: {
    LIST: '/special-day',
    DETAIL: '/special-day/:id',
    CREATE: '/special-day/create',
    UPDATE: '/special-day/update/:id',
  },
  NOTIFICATION: {
    LIST: '/notification',
    DETAIL: '/notification/:id',
    CREATE: '/notification/create',
    UPDATE: '/notification/update/:id',
  },
  AUTH: {
    LOGIN: '/login',
    FORGOT_PASSWORD: '/forgot-password',
    RESET_PASSWORD: '/reset-password/:code',
    UNAUTHORIZED: '/unauthorized',
  },
  PROMPT: {
    LIST: '/prompt',
    DETAIL: '/prompt/:id',
    CREATE: '/prompt/create',
    UPDATE: '/prompt/update/:id',
  },
  AYUMI: {
    LIST: '/ayumi',
    CREATE: '/ayumi/create',
    UPDATE: '/ayumi/update/:id',
  },
  EVENT: {
    LIST: '/event',
    DETAIL: '/event/:id',
    CREATE: '/event/create',
    UPDATE: '/event/update/:id',
  },
  BANNER: {
    LIST: '/banner',
    DETAIL: '/banner/:id',
    CREATE: '/banner/create',
    UPDATE: '/banner/update/:id',
  },
  CHAT_FUKUMARU: {
    LIST: '/chat-fukumaru',
    DETAIL: '/chat-fukumaru/:id',
    CREATE: '/chat-fukumaru/create',
    UPDATE: '/chat-fukumaru/update/:id',
  },
  CONTENT: {
    LIST: '/content',
  },
  ARTICLE: {
    LIST: '/articles',
  },
  OFFER: {
    LIST: '/offers',
  },
  CATEGORY: {
    LIST: '/categories',
  },
  ILLUSTRATION_THEME: {
    LIST: '/illustration-themes',
  },
  COGEVO_STAMP_IMAGE: {
    LIST: '/cogevo-stamp-images',
  },
  SCREEN_MEDIA: {
    LIST: '/screen-medias',
  },
  SURVEY: {
    LIST: '/survey',
  },
  NOTIFICATION_REMIND: {
    LIST: '/remind-notification',
  },
  SURVEY_HEALTH: {
    LIST: '/health-surveys',
    LIST_QUESTION: '/health-surveys/:id/questions',
  },
  VERSION: {
    LIST: '/app-version-settings',
    DETAIL: '/app-version-settings/:id',
    CREATE: '/app-version-settings/create',
    UPDATE: '/app-version-settings/update/:id',
  },
  CALENDAR_POST: {
    LIST: '/calendar-posts',
  },
  PARTNER: {
    LIST: '/partner',
    DETAIL: '/partner/:id',
    CREATE: '/partner/create',
    UPDATE: '/partner/update/:id',
  },
  COMPANY: {
    LIST: '/company',
    DETAIL: '/company/:id',
    CREATE: '/company/create',
  },
  MENU: {
    INQUIRY: '/inquiries',
  },
  FUKUMARU_QUIZ: {
    LIST: '/fukumaru-quiz',
    DETAIL: '/fukumaru-quiz/:id',
    CREATE: '/fukumaru-quiz/create',
    UPDATE: '/fukumaru-quiz/update/:id',
  },
  GAME_INTRODUCTION: {
    LIST: '/game-introduction',
    DETAIL: '/game-introduction/:id',
    CREATE: '/game-introduction/create',
    UPDATE: '/game-introduction/update/:id',
  },
  KAZOKUGOTO: {
    GENERATE: '/kazokugoto',
    PROMPTS: '/kazokugoto/prompts',
    CHARACTERS: '/kazokugoto/characters',
    ITEMS: '/kazokugoto/items',
    TOPICS: '/kazokugoto/topics',
  },
  AGENT: {
    RUN: '/agent',
    MESSAGES: '/agent/messages',
    PROMPTS: '/agent/prompts',
    FLOW: '/agent/flow',
    HENKA: '/agent/henka',
  },
  FAMILY: {
    LIST: '/families',
  },
  ADMIN_USER: {
    LIST: '/admin-users',
  },
};
